<script setup>
const { t } = useI18n()
</script>

<template>
  <div class="flex grow flex-col justify-between flex-gap-y-4 whitespace-pre-wrap">
    <DSAlert
      type="warning"
      no-close
      class="w-100%"
    >
      {{
        t('In order to register for this event, the manager must log into their account and complete any outstanding forms and waivers')
      }}
    </DSAlert>
  </div>
</template>

<i18n>
{
  "en-us": {
    "In order to register for this event, the manager must log into their account and complete any outstanding forms and waivers": "In order to register for this event, the manager must log into their account and complete any outstanding forms and waivers"
  }
}
</i18n>


<i18n locale="de" lang="json">
{
  "In order to register for this event, the manager must log into their account and complete any outstanding forms and waivers": "Um sich für diese Veranstaltung anzumelden, muss der Manager sich in sein Konto einloggen und alle ausstehenden Formulare und Verzichtserklärungen ausfüllen."
}
</i18n>

<i18n locale="es" lang="json">
{
  "In order to register for this event, the manager must log into their account and complete any outstanding forms and waivers": "Para registrarse en este evento, el gerente debe iniciar sesión en su cuenta y completar cualquier formulario y exención pendiente."
}
</i18n>

<i18n locale="fr" lang="json">
{
  "In order to register for this event, the manager must log into their account and complete any outstanding forms and waivers": "Pour s'inscrire à cet événement, le manager doit se connecter à son compte et remplir tous les formulaires et dérogations en attente."
}
</i18n>